import { registerComponent } from '@gig/magic-common';
import AllowedCountriesModalComponent from './allowed-countries-modal.vue.js';

var AllowedCountriesModal = registerComponent(AllowedCountriesModalComponent);

export { AllowedCountriesModal };
